import gql from "graphql-tag";

export const RealestatePropertyByLocation = `query RealestatePropertyByLocation($locationid: ID!, $pagenumber: Int, $pagesize: Int,$searchtext: String,$filters: [Filter!],$filterid: ID) {
  realestatePropertyByLocation(locationid: $locationid, pagenumber: $pagenumber, pagesize: $pagesize,searchtext: $searchtext,filters: $filters, filterid: $filterid) {
    count
    rows {
      realestatepropertyid
      address
      cargarage
      builtyear
      city
      currency
      state
      county
      country
      zipcode
      bedroom
      bathroom
      price
      mlsid
      entityname
      entitytype
      squarefeet
      buyercontacts
      sellercontacts
      status
      fromprice
      commission
      toprice
      agentUsers {
      firstname
      email
      userid
      lastname
      avatar
      phonenumber
    }
      propertytype
      buildingtype
      ownership
      location
      propertysize
      lotsize
      storeys
      notes
      description
      purchasedate
      purchaseprice
      moveidate
      propertytaxes
      mortgageamount
      mortgageterm
      mortgagerate
      mortgageexpirydate
      saledate
      saleprice
      propertyattribute1
      propertyattribute2
      propertyattribute3
      propertyattribute4
      propertyattribute5
      propertyattribute6
      propertyattribute7
      propertyattribute8
      propertyattribute9
      propertyattribute10
      propertyattribute11
      propertyattribute12
      propertyattribute13
      propertyattribute14
      propertyattribute15
      propertyattribute16
      propertyattribute17
      propertyattribute18
      propertyattribute19
      propertyattribute20
      buyerContactList {
        firstname
        lastname
      }
      sellerContactList {
        firstname
        lastname
      }
      createdAt
    }
  }
}`;

export const RealestatePropertyById = `query RealestateProperty($realestatepropertyid: ID!) {
  realestateProperty(realestatepropertyid: $realestatepropertyid) {
    realestatepropertyid
    photos
    commission
    city
    state
    country
    agents
    floorplan
    entityname
    entitytype
    agentUsers {
      firstname
      email
      userid
      lastname
      avatar
      phonenumber
      govid
      corporatelicno
    }
    businesses {
      businessentity
      businessname
      businessprice
      businesstype
      contacttype
      businessowner
      entitydescription
      propertybusinessid
      businessentitylevel
      businessentityresponsible
      updatedby
      updatedAt
      createdby
      createdAt
      createdUser {
        firstname
        email
        lastname
      }
      updatedUser {
        firstname
        email
        lastname
      }
    }
    zipcode
    builtyear
    cargarage
    bedroom
    bathroom
    price
    mlsid
    currency
    squarefeet
    buyercontacts
    sellercontacts
    status
    fromprice
    toprice
    propertytype
    buildingtype
    ownership
    location
    propertysize
    lotsize
    storeys
    notes
    description
    purchasedate
    purchaseprice
    moveidate
    propertytaxes
    mortgageamount
    mortgageterm
    mortgagerate
    mortgageexpirydate
    saledate
    saleprice
    propertyattribute1
    propertyattribute2
    propertyattribute3
    propertyattribute4
    propertyattribute5
    propertyattribute6
    propertyattribute7
    propertyattribute8
    propertyattribute9
    propertyattribute10
    propertyattribute11
    propertyattribute12
    propertyattribute13
    propertyattribute14
    propertyattribute15
    propertyattribute16
    propertyattribute17
    propertyattribute18
    propertyattribute19
    propertyattribute20
    locationid
    deleted
    businessid
    createdby
    buyerContactList {
      firstname
      lastname
      phonenumber
      phonecountryid
      organization {
        organizationid
        name
      }
      address {
        city
        county
        state {
          name
        }
        street1
        street2
        zip
      }
      contactid
      primaryemail
    }
    sellerContactList {
      firstname
      lastname
      phonenumber
      phonecountryid
      organization {
        organizationid
        name
      }
      address {
        city
        county
        state {
          name
        }
        street1
        street2
        zip
      }
      primaryemail
      contactid
    }
      transactions {
      transactionid
      transactiondate
      documents
      address
      status
      price
      currency
      notes
      commission
      ownershiptype
      commissionamount
      amountforleasepermonth
      noofmonths
      commissionvalue
      updatedAt
      updatedby
      createdAt
      createdUser {
        firstname
        lastname
      }
        updatedUser {
        firstname
        lastname
      }
    }
    createdAt
    updatedAt
    address
    county
  }
}`;

export const CreateProperty = `mutation CreateRealestateProperty($address: String!, $businessid: ID!, $locationid: ID!, $createdby: ID!, $photos: [String], $city: String, $state: String, $floorplan: [String], $country: String, $zipcode: String, $cargarage: Float, $builtyear: String, $bedroom: String, $bathroom: String, $price: Float, $currency: String, $mlsid: String, $squarefeet: Float, $agents: [ID!], $buyercontacts: [ID], $sellercontacts: [ID], $status: String, $fromprice: Int, $toprice: Int, $propertytype: String, $buildingtype: String, $ownership: String, $location: String, $propertysize: Float, $lotsize: Float, $storeys: String, $notes: String, $mortgageexpirydate: Date, $commission: Float, $propertyattribute1: String, $propertyattribute2: String, $propertyattribute3: String, $propertyattribute4: String, $propertyattribute5: String, $propertyattribute6: String, $propertyattribute7: String, $propertyattribute8: String, $propertyattribute9: String, $propertyattribute10: String, $propertyattribute11: String, $propertyattribute12: String, $propertyattribute13: String, $propertyattribute14: String, $propertyattribute15: String, $propertyattribute16: String, $propertyattribute17: String, $propertyattribute18: String, $propertyattribute19: String, $propertyattribute20: String,$county: String,$entityname: String, $entitytype: String) {
  createRealestateProperty(address: $address, businessid: $businessid, locationid: $locationid,county: $county, cargarage: $cargarage, builtyear: $builtyear, createdby: $createdby, photos: $photos, city: $city, state: $state, country: $country, zipcode: $zipcode, bedroom: $bedroom, bathroom: $bathroom, price: $price, currency: $currency, mlsid: $mlsid, squarefeet: $squarefeet, buyercontacts: $buyercontacts, sellercontacts: $sellercontacts, status: $status, fromprice: $fromprice, toprice: $toprice, propertytype: $propertytype, buildingtype: $buildingtype, ownership: $ownership, location: $location, propertysize: $propertysize, agents: $agents, lotsize: $lotsize, storeys: $storeys, notes: $notes, mortgageexpirydate: $mortgageexpirydate, floorplan: $floorplan, commission: $commission, propertyattribute1: $propertyattribute1, propertyattribute2: $propertyattribute2, propertyattribute3: $propertyattribute3, propertyattribute4: $propertyattribute4, propertyattribute5: $propertyattribute5, propertyattribute6: $propertyattribute6, propertyattribute7: $propertyattribute7, propertyattribute8: $propertyattribute8, propertyattribute9: $propertyattribute9, propertyattribute10: $propertyattribute10, propertyattribute11: $propertyattribute11, propertyattribute12: $propertyattribute12, propertyattribute13: $propertyattribute13, propertyattribute14: $propertyattribute14, propertyattribute15: $propertyattribute15, propertyattribute16: $propertyattribute16, propertyattribute17: $propertyattribute17, propertyattribute18: $propertyattribute18, propertyattribute19: $propertyattribute19, propertyattribute20: $propertyattribute20,entityname: $entityname, entitytype: $entitytype) {
    realestatepropertyid
  }
}`;

export const UpdateProperty = `mutation EditRealestateProperty($realestatepropertyid: ID!, $address: String!, $updatedby: ID!, $photos: [String], $city: String, $state: String, $country: String, $zipcode: String, $bedroom: String, $bathroom: String, $price: Float, $currency: String, $mlsid: String, $squarefeet: Float, $buyercontacts: [ID], $sellercontacts: [ID], $floorplan: [String], $status: String, $fromprice: Int, $toprice: Int, $propertytype: String, $buildingtype: String, $ownership: String, $location: String, $propertysize: Float, $lotsize: Float, $storeys: String, $notes: String, $cargarage: Float, $builtyear: String, $agents: [ID!], $mortgageexpirydate: Date, $commission: Float, $propertyattribute1: String, $propertyattribute2: String, $propertyattribute3: String, $propertyattribute4: String, $propertyattribute5: String, $propertyattribute6: String, $propertyattribute7: String, $propertyattribute8: String, $propertyattribute9: String, $propertyattribute10: String, $propertyattribute11: String, $propertyattribute12: String, $propertyattribute13: String, $propertyattribute14: String, $propertyattribute15: String, $propertyattribute16: String, $propertyattribute17: String, $propertyattribute18: String, $propertyattribute19: String, $propertyattribute20: String,$county: String,$entityname: String, $entitytype: String) {
  editRealestateProperty(realestatepropertyid: $realestatepropertyid, address: $address, updatedby: $updatedby, photos: $photos, cargarage: $cargarage, builtyear: $builtyear, city: $city, state: $state, country: $country, zipcode: $zipcode, bedroom: $bedroom, bathroom: $bathroom,county: $county, price: $price, currency: $currency, mlsid: $mlsid, squarefeet: $squarefeet, buyercontacts: $buyercontacts, sellercontacts: $sellercontacts, status: $status, fromprice: $fromprice, toprice: $toprice, propertytype: $propertytype, floorplan: $floorplan, buildingtype: $buildingtype, ownership: $ownership, location: $location, propertysize: $propertysize, lotsize: $lotsize, agents: $agents, storeys: $storeys, notes: $notes, mortgageexpirydate: $mortgageexpirydate, commission: $commission, propertyattribute1: $propertyattribute1, propertyattribute2: $propertyattribute2, propertyattribute3: $propertyattribute3, propertyattribute4: $propertyattribute4, propertyattribute5: $propertyattribute5, propertyattribute6: $propertyattribute6, propertyattribute7: $propertyattribute7, propertyattribute8: $propertyattribute8, propertyattribute9: $propertyattribute9, propertyattribute10: $propertyattribute10, propertyattribute11: $propertyattribute11, propertyattribute12: $propertyattribute12, propertyattribute13: $propertyattribute13, propertyattribute14: $propertyattribute14, propertyattribute15: $propertyattribute15, propertyattribute16: $propertyattribute16, propertyattribute17: $propertyattribute17, propertyattribute18: $propertyattribute18, propertyattribute19: $propertyattribute19, propertyattribute20: $propertyattribute20,entityname: $entityname, entitytype: $entitytype)
}`;

export const DeleteProperty = `mutation DeleteRealestateProperty($realestatepropertyid: ID!) {
  deleteRealestateProperty(realestatepropertyid: $realestatepropertyid)
}`;

export const CreatePropertyTransaction = `mutation CreatePropertyTransaction($realestatepropertyid: ID!, $transactiondate: Date, $address: String, $status: String, $price: Float, $currency: String, $notes: String, $commission: Float,$createdby: ID!, $ownershiptype: String, $commissiontype: String, $noofmonths: Float, $commissionamount: Float, $amountforleasepermonth: Float, $documents: [String], $commissionvalue: Float) {
  createPropertyTransaction(realestatepropertyid: $realestatepropertyid, transactiondate: $transactiondate, address: $address, status: $status, price: $price, currency: $currency, notes: $notes, commission: $commission,createdby: $createdby, ownershiptype: $ownershiptype, commissiontype: $commissiontype, noofmonths: $noofmonths, commissionamount: $commissionamount, amountforleasepermonth: $amountforleasepermonth, documents: $documents, commissionvalue: $commissionvalue) {
    transactionid
  }
}`;

export const EditPropertyTransaction = `mutation EditPropertyTransaction($realestatepropertyid: ID!, $transactionid: ID!, $transactiondate: Date, $address: String, $status: String, $price: Float, $currency: String, $notes: String, $commission: Float,$updatedby: ID!, $ownershiptype: String, $commissionamount: Float, $noofmonths: Float, $commissiontype: String, $amountforleasepermonth: Float, $documents: [String], $commissionvalue: Float) {
  editPropertyTransaction(realestatepropertyid: $realestatepropertyid, transactionid: $transactionid, transactiondate: $transactiondate, address: $address, status: $status, price: $price, currency: $currency, notes: $notes, commission: $commission,updatedby: $updatedby, ownershiptype: $ownershiptype, commissionamount: $commissionamount, noofmonths: $noofmonths, commissiontype: $commissiontype, amountforleasepermonth: $amountforleasepermonth, documents: $documents, commissionvalue: $commissionvalue) {
    transactionid
  }
}`;

export const DeletePropertyTransaction = `mutation DeletePropertyTransaction($realestatepropertyid: ID!, $transactionid: ID!) {
  deletePropertyTransaction(realestatepropertyid: $realestatepropertyid, transactionid: $transactionid) {
    transactionid
  }
}`;

export const CustomPropertiesForRealestate = `query CustomPropertiesForRealestate($businessid: ID!, $objecttype: [String!]) {
  customPropertiesForRealestate(businessid: $businessid, objecttype: $objecttype) {
    name
    value
    type
    table
  }
}`;

export const PropertyTransactionsyByLocation = `query PropertyTransactionsyByLocation($locationid: ID!, $searchtext: String, $pagenumber: Int, $pagesize: Int, $sortby: SortBy) {
  propertyTransactionsyByLocation(locationid: $locationid, searchtext: $searchtext, pagenumber: $pagenumber, pagesize: $pagesize, sortby: $sortby) {
    count
    rows {
    realestatepropertyid
      transaction {
        commission
        price
        notes
        transactionid
        amountforleasepermonth
        commissionamount
        noofmonths
        ownershiptype
        commissionvalue
        documents
        createdUser {
          lastname
          firstname
        }
        currency
        address
        transactiondate
        createdAt
        updatedAt
        updatedUser {
          firstname
          lastname
        }
      }
    }
  }
}`;

export const PropertyListApi = `query RealestatePropertyByLocation($locationid: ID!, $searchtext: String, $pagenumber: Int, $pagesize: Int) {
  realestatePropertyByLocation(locationid: $locationid, searchtext: $searchtext, pagenumber: $pagenumber, pagesize: $pagesize) {
    count
    rows {
      address
      realestatepropertyid
    }
  }
}`;

export const DeleteView = `
        mutation
        deletesavedfilter(
          $filterid: ID!
            ){
              deletesavedfilter(
                filterid:$filterid
                )
            }`;

export const LocationByName = `query locationbyname($name: String!, $businessid: ID!)
                                    { locationbyname(name:$name,businessid:$businessid){
                                        entityid,
                                        businessname,
                                        brandname
                                firstname,
                                lastname,email,
                                phonenumber,
                                entitytypeid,
                                businesstypeid,
                                jobid,
                                tags,
                                website,
                                shortdesc,
                                fulldesc,
                                publicpageviewcount
                                      }}`

export const BusinessByName = `query  businessbyname($name: String!)
                                {businessbyname(name:$name){
                                    entityid,
                                    businessname,
                                    brandname
                            firstname,
                            lastname,email,
                            phonenumber,
                            entitytypeid,
                            businesstypeid,
                            jobid,
                            tags,
                            website,
                            shortdesc,
                            fulldesc
                                  }}
                          `;

export const QueryEntityByEntityId = `query entity($entityid:ID!){entity(entityid:$entityid){entityid,businessname,brandname
                          firstname,lastname,email,phonenumber,entitytypeid,businesstypeid,jobid,tags,website,shortdesc,fulldesc,publicpageviewcount,createdby,updatedby,
                          }}`;

export const LookupData = `query lookupdata($lookupid:ID!)
        {lookupdata(lookupid:$lookupid){key,name}}`;

export const UserListByBusinessAndLocation = `query userListByBusinessAndLocation($businessid: ID!, $locationid: ID!, $includeusersid: [ID]) {
  userListByBusinessAndLocation(businessid: $businessid, locationid: $locationid, includeusersid: $includeusersid) {
    userid
    firstname
    lastname
    phonenumber
    email
  }
}`;

export const CreatePropertyBusiness = `mutation CreatePropertyBusiness($realestatepropertyid: ID!, $createdby: ID!, $businessname: String, $entitydescription: String, $businessentity: String, $businessprice: Float, $businesstype: String, $contacttype: String, $businessentitylevel: String, $businessentityresponsible: String, $businessowner: String) {
  createPropertyBusiness(realestatepropertyid: $realestatepropertyid, createdby: $createdby, businessname: $businessname, entitydescription: $entitydescription, businessentity: $businessentity, businessprice: $businessprice, businesstype: $businesstype, contacttype: $contacttype,businessentitylevel: $businessentitylevel, businessentityresponsible: $businessentityresponsible, businessowner: $businessowner) {
    propertybusinessid
  }
}`;

export const EditPropertyBusiness = `mutation EditPropertyBusiness($realestatepropertyid: ID!, $propertybusinessid: ID!, $updatedby: ID!, $businessname: String, $entitydescription: String, $businessentity: String, $businessprice: Float, $businesstype: String, $contacttype: String, $businessentitylevel: String, $businessentityresponsible: String, $businessowner: String) {
  editPropertyBusiness(realestatepropertyid: $realestatepropertyid, propertybusinessid: $propertybusinessid, updatedby: $updatedby, businessname: $businessname, entitydescription: $entitydescription, businessentity: $businessentity, businessprice: $businessprice, businesstype: $businesstype, contacttype: $contacttype, businessentitylevel: $businessentitylevel, businessentityresponsible: $businessentityresponsible, businessowner: $businessowner) {
    propertybusinessid
  }
}`;

export const DeletePropertyBusiness = `mutation DeletePropertyBusiness($realestatepropertyid: ID!, $propertybusinessid: ID!) {
  deletePropertyBusiness(realestatepropertyid: $realestatepropertyid, propertybusinessid: $propertybusinessid) {
    propertybusinessid
  }
}`;

export const DocumentByRealestateproperty = `query DocumentByRealestateproperty($realestatepropertyid: ID!) {
  documentByRealestateproperty(realestatepropertyid: $realestatepropertyid) {
    description
    documents
    documentid
    realestatepropertyid
    title
    createdAt
    createdby
    updatedAt
    updatedby
  }
}`;

export const CreatePropertyDocument = gql`mutation CreateContactDocument($title: String!, $createdby: ID!, $description: String, $documents: [Upload!], $realestatepropertyid: ID, $type: Int) {
  createContactDocument(title: $title, createdby: $createdby, description: $description, documents: $documents, realestatepropertyid: $realestatepropertyid, type: $type) {
    realestatepropertyid
  }
}`;

export const EditPropertyDocument = gql`mutation EditContactDocument($documentid: ID!, $title: String!, $updatedby: ID!, $realestatepropertyid: ID, $description: String, $documents: [Upload!], $type: Int) {
  editContactDocument(documentid: $documentid, title: $title, updatedby: $updatedby, description: $description, documents: $documents, type: $type, realestatepropertyid: $realestatepropertyid)
}`;

export const DeletePropertyDocument = `mutation DeleteContactDocument($documentid: ID!) {
  deleteContactDocument(documentid: $documentid)
}`;